<template>
  <v-app>

    <v-app-bar v-if="appBar" app clipped-left small :class="`${$vuetify.theme.dark ? '':'white'}`" flat>
      <v-app-bar-nav-icon @click="leftNav = !leftNav"></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <v-img
          alt="Logo"
          class="shrink mr-4"
          contain
          src="data:image/svg+xml;charset=utf-8,%3Csvg width='135' height='29' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 14.498c0 6.204 3.846 11.493 9.26 13.57V.93C3.845 3.007 0 8.295 0 14.498zM14.339 0c-.397 0-.79.014-1.179.043v1.02h.073c5.465.04 9.865 4.254 9.826 9.413-.036 5.135-4.464 9.27-9.897 9.265v9.213c.387.033.781.046 1.178.046 7.916 0 14.34-6.493 14.34-14.502C28.68 6.49 22.256 0 14.34 0zm27.529 17.882h-4.62l-.81 2.417h-2.036l3.958-11.6h2.44l3.926 11.6h-2.052l-.806-2.417zm-.583-1.749l-1.729-5.145-1.73 5.145h3.46zm9.515-4.296h1.972V20.3h-1.971v-.98h-.065c-.533.735-1.26 1.193-2.375 1.193-1.696 0-2.795-1.241-2.795-3.136v-5.539h1.972v5.326c0 .948.452 1.634 1.535 1.634 1.13 0 1.729-.8 1.729-1.765v-5.195H50.8zm5.286 6.012c.13.75.63 1.209 1.68 1.209.97 0 1.52-.41 1.52-1.11 0-.572-.21-.916-1.115-1.03l-1.503-.18c-1.712-.196-2.423-1.014-2.423-2.336 0-1.617 1.357-2.776 3.457-2.776 2.197 0 3.264 1.29 3.362 2.564h-1.94c-.097-.685-.581-1.11-1.453-1.11-.905 0-1.487.425-1.487 1.079 0 .539.29.85 1.26.964l1.487.18c1.648.195 2.295.964 2.295 2.369 0 1.748-1.503 2.841-3.474 2.841-2.278 0-3.49-1.126-3.65-2.663h1.984v-.001zm7.286-4.542h-1.599v-1.47h1.617V8.7h1.954v3.136h1.923v1.47h-1.923v4.345c0 .769.387 1.08 1.132 1.08h.807v1.568h-1.147c-1.859 0-2.764-.85-2.764-2.516v-4.476zm7.545 6.992h-1.972v-8.462h1.972v1.275h.065c.404-.931 1.082-1.275 1.793-1.275h.954v1.765h-.872c-1.309 0-1.939.636-1.939 2.19v4.507zm5.977.213c-1.599 0-2.681-.948-2.681-2.532 0-1.665 1.26-2.303 2.634-2.483l1.777-.23c.678-.064.84-.375.84-.865 0-.72-.469-1.274-1.454-1.274-1.002 0-1.534.555-1.616 1.34h-2.003c.048-1.439 1.244-2.842 3.57-2.842 2.197 0 3.49 1.306 3.49 3.234v3.986c0 .524.081 1.046.178 1.454h-2.036a7.342 7.342 0 01-.08-1.094h-.049c-.436.733-1.358 1.306-2.57 1.306zm1.52-4.1l-.873.195c-.824.18-1.34.524-1.34 1.29 0 .77.451 1.16 1.324 1.16 1.019 0 1.955-.669 1.955-1.78v-1.324c-.242.246-.63.36-1.067.459zm4.766 1.6v-9.9h1.971v9.77c0 .523.227.85.808.85h.647v1.567h-1.034c-1.536 0-2.392-.881-2.392-2.287zm6.947-8.822c0 .685-.534 1.209-1.212 1.209a1.194 1.194 0 01-1.212-1.21c0-.685.534-1.209 1.212-1.209.678 0 1.212.524 1.212 1.21zm-.227 2.647V20.3h-1.972v-8.462H89.9zm4.057 8.675c-1.599 0-2.682-.948-2.682-2.532 0-1.665 1.26-2.303 2.635-2.483l1.776-.23c.679-.064.84-.375.84-.865 0-.72-.468-1.274-1.453-1.274-1.003 0-1.535.555-1.616 1.34h-2.004c.049-1.439 1.245-2.842 3.57-2.842 2.198 0 3.491 1.306 3.491 3.234v3.986c0 .524.08 1.046.178 1.454h-2.036a7.342 7.342 0 01-.08-1.094h-.05c-.437.733-1.357 1.306-2.569 1.306zm1.519-4.1l-.872.195c-.825.18-1.341.524-1.341 1.29 0 .77.453 1.16 1.325 1.16 1.018 0 1.955-.669 1.955-1.78v-1.324c-.243.246-.632.36-1.067.459zM108.4 8.7c2.472 0 4.039 1.42 4.039 3.756 0 2.386-1.583 3.79-4.039 3.79h-2.893V20.3h-2.083V8.7h4.976zm1.923 3.758c0-1.438-.872-2.042-2.31-2.042h-2.504v4.117h2.504c1.438 0 2.31-.573 2.31-2.075zm6.56-.818c2.424 0 4.04 1.749 4.04 4.444s-1.616 4.427-4.04 4.427c-2.423 0-4.039-1.732-4.039-4.427 0-2.695 1.616-4.444 4.039-4.444zm2.035 4.102c0-1.585-.776-2.516-2.036-2.516-1.261 0-2.036.931-2.036 2.516v.686c0 1.584.775 2.5 2.036 2.5 1.26 0 2.036-.916 2.036-2.5v-.686zm4.864 2.107c.129.75.629 1.209 1.68 1.209.97 0 1.519-.41 1.519-1.11 0-.572-.21-.916-1.114-1.03l-1.503-.18c-1.712-.196-2.424-1.014-2.424-2.336 0-1.617 1.357-2.776 3.458-2.776 2.197 0 3.263 1.29 3.361 2.564h-1.939c-.097-.685-.582-1.11-1.454-1.11-.905 0-1.487.425-1.487 1.079 0 .539.291.85 1.261.964l1.487.18c1.647.195 2.294.964 2.294 2.369 0 1.748-1.503 2.841-3.473 2.841-2.279 0-3.491-1.126-3.651-2.663h1.985v-.001zm7.286-4.542h-1.599v-1.47h1.616V8.7h1.954v3.136h1.923v1.47h-1.923v4.345c0 .769.388 1.08 1.132 1.08h.807v1.568h-1.147c-1.858 0-2.763-.85-2.763-2.516v-4.476z' fill='%23DC1928'/%3E%3C/svg%3E"
          transition="scale-transition"
          width="100%"
        />
      </div>

      <v-spacer></v-spacer>
      <v-text-field v-model="search" flat single-line rounded dense hide-details outlined clearable
                    label="Search parcel manifest"></v-text-field>
      <v-spacer></v-spacer>

      <!--      <v-btn text rounded outlined class="mr-5" color="primary" to="/app">view app</v-btn>-->

      <!--<v-menu bottom left offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" outlined>
            <v-icon>mdi-account-circle-outline</v-icon>
          </v-btn>
        </template>

        <v-list flat dense>
          <v-list-item flat @click="loginDialog = !loginDialog">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>-->

    </v-app-bar>

    <v-navigation-drawer app v-model="leftNav" disable-resize-watcher clipped fixed flat
                         :class="`${$vuetify.theme.dark ? '': 'grey lighten-3'}`">
      <v-divider></v-divider>

      <v-list dense>
        <v-list-item v-for="item in items" :key="item.title" :to="item.link">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Dark Mode</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch dense hide-details v-model="darkMode"></v-switch>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="rightNav" v-if="$store.state.selectedData !== null" permanent fixed nav app right flat
                         :class="`${$vuetify.theme.dark ? '': 'grey lighten-3'} flex-md-column`" width="30%">
      <v-list>
        <v-list-item dense>
          <v-list-item-content class="title">MANIFEST DETAILS</v-list-item-content>
          <v-list-item-icon small>
            <v-btn icon @click="closeRightNav(null)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-list-item-icon>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-container fluid>
        <v-row dense class="mb-6">
          <v-col cols="6">
            <v-card flat outlined>
              <v-card-text>
                <span class="caption">Product Type</span>
                <br>
                <span class="font-weight-bold">{{ $store.state.selectedData.value.type || 'n/a'}}</span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card flat outlined>
              <v-card-text class="font-weight-medium">
                <span class="caption">Size</span>
                <br>
                <span class="font-weight-bold">{{ $store.state.selectedData.value.size || 'n/a'}}</span></v-card-text>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card flat outlined>
              <v-card-text class="font-weight-medium text-end">
                <span class="caption">Weight</span>
                <br>
                <span class="font-weight-bold">{{ $store.state.selectedData.value.weight || 'n/a'}}</span></v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-expansion-panels v-model="panel" flat multiple outline class="elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="font-weight-medium">RECEIVER DETAILS</span>
              <v-spacer></v-spacer>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list dense>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_to.full_name || 'n/a' }}</span>
                      </template>
                      <span>Recipient name.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-phone</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_to.mobile_no || 'n/a' }}</span>
                      </template>
                      <span>Recipient mobile number.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-map-marker</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_to.full_address || 'n/a' }}</span>
                      </template>
                      <span>Scanned address.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-api</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_to.ame_address || 'n/a' }}</span>
                      </template>
                      <span>Recipient AME resulting address.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-google-maps</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_to.gcp_address || 'n/a' }}</span>
                      </template>
                      <span>Recipient GCP resulting address.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-clock</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_to.scan_time ?
                    $store.state.selectedData.value.manifest_to.scan_time.toFixed(5) : 'n/a' }}</span></template>
                      <span>Recipient scan duration.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-calendar</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_to.date_created ?
                    format($store.state.selectedData.value.manifest_to.date_created) : 'n/a' }}</span></template>
                      <span>Date created.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
              <v-row justify="end">
                <v-btn text rounded outlined class="ml-3"
                       @click="viewImage($store.state.selectedData.value.manifest_to.image)">
                  view image
                </v-btn>
                <v-btn text rounded outlined class="ml-3"
                       @click="viewRawData($store.state.selectedData.value.manifest_to.id)">
                  raw data
                </v-btn>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="font-weight-medium">SENDER DETAILS</span>
              <v-spacer></v-spacer>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list dense>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_fr.full_name || 'n/a'}}</span>
                      </template>
                      <span>Sender name.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-phone</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_fr.mobile_no || 'n/a'}}</span>
                      </template>
                      <span>Sender mobile number.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-map-marker</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_fr.full_address || 'n/a' }}</span>
                      </template>
                      <span>Scanned address.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-api</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_fr.ame_address || 'n/a' }}</span>
                      </template>
                      <span>Sender AME resulting address.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-google-maps</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_fr.gcp_address || 'n/a' }}</span>
                      </template>
                      <span>Sender GCP resulting address.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-clock</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{ $store.state.selectedData.value.manifest_fr.scan_time ?
                        $store.state.selectedData.value.manifest_fr.scan_time.toFixed(5) : 'n/a' }}
                        </span></template>
                      <span>Scan duration in seconds.</span></v-tooltip>
                  </v-list-item-title>

                </v-list-item>
                <v-list-item>
                  <v-list-item-icon small>
                    <v-icon size="20">mdi-calendar</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ $store.state.selectedData.value.manifest_fr.date_created ?
                    format($store.state.selectedData.value.manifest_fr.date_created) : 'n/a' }}</span></template>
                      <span>Date created.</span></v-tooltip>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
              <v-row justify="end">
                <v-btn text rounded outlined class="ml-3"
                       @click="viewImage($store.state.selectedData.value.manifest_fr.image)">
                  view image
                </v-btn>
                <v-btn text rounded outlined class="ml-3"
                       @click="viewRawData($store.state.selectedData.value.manifest_fr.id)">
                  raw data
                </v-btn>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
      </v-container>
    </v-navigation-drawer>

    <v-content :class="`${$vuetify.theme.dark ? '': 'grey lighten-3'} wrap`" v-if="!loginDialog">
      <router-view/>
    </v-content>

    <v-dialog v-model="loginDialog" fullscreen dark persistent app>
      <v-card flat>
        <v-content>
          <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="8" md="4">
                <v-card flat>
                  <v-card-title class="justify-center">SALI TESTING ENV</v-card-title>
                  <v-card-text>
                    <v-text-field label="Username" outlined rounded></v-text-field>
                    <v-text-field label="Password" type="password" outlined rounded></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn block large rounded outlined @click="loginDialog = !loginDialog">Login</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-content>
      </v-card>
    </v-dialog>

    <viewer :images="[selectedImage]" ref="viewer" @inited="initViewer" :options="viewerOptions">
      <img v-for="image in [selectedImage]" style="display: none;" :src="image" width="300px" :key="image"/>
    </viewer>

    <v-dialog v-model="rawDataDialog">
      <v-card>
        <v-sheet v-if="isFetchingRaw" :color="`${$vuetify.theme.dark ? '': 'grey lighten-4'}`" class="px-3 pt-3 pb-12">
          <v-responsive class="mx-auto">
            <v-skeleton-loader ref="skeleton" type="card" class="mx-auto"></v-skeleton-loader>
          </v-responsive>
        </v-sheet>
        <v-card-text v-else class="text-lg-justify wrap">
          <json-viewer
            :value="rawData"
            :expand-depth=3
            :copyable="{copyText: 'COPY', copiedText: 'Copied to clipboard'}"
            sort
            :theme="`${$vuetify.theme.dark ? 'json-viewer-dark-theme' : 'json-viewer-light-theme'}`"
          ></json-viewer>
        </v-card-text>
        <v-card-actions>
          <v-btn text block outlined @click="closeRawDataDialog">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-alert v-if="$store.state.alert" v-model="alert" :type="$store.state.alert.type" dismissible prominent
             transition="slide-y-transition">
      {{ $store.state.alert.message }}
    </v-alert>
  </v-app>
</template>

<script>
import {format} from 'timeago.js'
import 'viewerjs/dist/viewer.css'
import _debounce from 'lodash.debounce'

export default {
  name: 'App',
  beforeMount() {
    // Init store values from localStorage
    this.$store.commit('initStore')

    // Hide app bar and left nav bar
    this.$store.commit('setState', ['leftNav', false])
    this.$store.commit('setState', ['appBar', false])
  },
  methods: {
    closeRightNav(val) {
      this.$store.commit('setSelectedData', val)
    },
    initViewer(viewer) {
      this.$viewer = viewer
    },
    viewImage(image) {
      this.selectedImage = image
      this.imageViewDialog = true
      this.$viewer.view()
    },
    async viewRawData(id) {
      this.rawDataDialog = true
      this.isFetchingRaw = true
      this.rawData = await this.$server.get(this.$store.state.manifestServerAddress + `/v1/manifests/${id}/raw`).json().catch(error => {
        console.error('Error on fetching manifest raw data.', error)
      })
      this.isFetchingRaw = false
    },
    closeImageViewDialog() {
      this.imageViewDialog = false
      this.selectedImage = null
    },
    closeRawDataDialog() {
      this.rawDataDialog = false
      this.rawData = null
    },
    format
  },
  computed: {
    alert: {
      get() {
        return this.$store.state.alert !== null
      },
      set() {
        this.$store.commit('setState', ['alert', null])
      }
    },
    search: {
      get() {
        return this.$store.state.search
      },
      set: _debounce(function (val) {
        this.$store.commit('setState', ['search', val])
      }, 500)
    },
    leftNav: {
      get() {
        return this.$store.state.leftNav
      },
      set(val) {
        this.$store.commit('setState', ['leftNav', val])
      }
    },
    appBar: {
      get() {
        return this.$store.state.appBar
      },
      set(val) {
        this.$store.commit('setState', ['appBar', val])
      }
    },
    rightNav: {
      get() {
        return this.$store.state.selectedData != null
      },
      set() {
      }
    },
    darkMode: {
      get() {
        return this.$vuetify.theme.dark
      },
      set(val) {
        this.$vuetify.theme.dark = val
        this.$store.commit('setDarkMode', val)
      }
    }

  },
  data: () => ({
    panel: [0, 1],
    disabled: false,
    readonly: false,
    loginDialog: false,
    items: [
      {title: 'Parcels', icon: 'mdi-package', link: 'parcels'},
      {title: 'CN22', icon: 'mdi-newspaper', link: 'cn22'},
      // {title: 'Manifests', icon: 'mdi-image', link: 'manifests'},
      // {title: 'Transactions', icon: 'mdi-view-dashboard', link: 'transactions'},
    ],
    selectedImage: null,
    imageViewDialog: false,
    rawData: null,
    rawDataDialog: false,
    isFetchingRaw: false,
    viewerOptions: {
      "inline": false,
      "button": true,
      "navbar": false,
      "title": true,
      "toolbar": false,
      "tooltip": true,
      "movable": true,
      "zoomable": true,
      "rotatable": true,
      "scalable": true,
      "transition": true,
      "fullscreen": false,
      "keyboard": true,
      "url": "data-source"
    }
  })
}
</script>

<style lang="scss">
  .json-viewer-light-theme {
    background: #fff;
    white-space: nowrap;
    color: #525252;
    font-size: 14px;
    font-family: Consolas, Menlo, Courier, monospace;

    .jv-ellipsis {
      color: #999;
      background-color: #eee;
      display: inline-block;
      line-height: 0.9;
      font-size: 0.9em;
      padding: 0px 4px 2px 4px;
      border-radius: 3px;
      vertical-align: 2px;
      cursor: pointer;
      user-select: none;
    }

    .jv-button {
      color: #49b3ff
    }

    .jv-key {
      color: #111111;
      margin-right: 4px;
    }

    .jv-item {
      &.jv-array {
        color: #111111
      }

      &.jv-boolean {
        color: #fc1e70;
        font-style: italic;
      }

      &.jv-function {
        color: #067bca
      }

      &.jv-number {
        color: #fc1e70
      }

      &.jv-object {
        color: #111111
      }

      &.jv-undefined {
        color: #e08331
      }

      &.jv-string {
        color: #42b983;
        word-break: break-word;
        white-space: normal;
      }
    }

    .jv-code {
      .jv-toggle {
        &:before {
          padding: 0px 2px;
          border-radius: 2px;
        }

        &:hover {
          &:before {
            background: #eee;
          }
        }
      }
    }
  }

  .json-viewer-dark-theme {
    background: #202020;
    white-space: nowrap;
    color: #dedede;
    font-size: 14px;
    font-family: Consolas, Menlo, Courier, monospace;

    .jv-ellipsis {
      color: #ffffff;
      background-color: #696969;
      display: inline-block;
      line-height: 0.9;
      font-size: 0.9em;
      padding: 0px 4px 2px 4px;
      border-radius: 3px;
      vertical-align: 2px;
      cursor: pointer;
      user-select: none;
    }

    .jv-button {
      color: #49b3ff
    }

    .jv-key {
      color: #55d2d4;
      margin-right: 4px;
    }

    .jv-item {
      &.jv-array {
        color: #111111
      }

      &.jv-boolean {
        color: #99bbfc;
        font-style: italic;
      }

      &.jv-function {
        color: #067bca
      }

      &.jv-number {
        color: #fc1e70
      }

      &.jv-object {
        color: #c3c3c3
      }

      &.jv-undefined {
        color: #e08331
      }

      &.jv-string {
        color: #51eaa6;
        word-break: break-word;
        white-space: normal;
      }
    }

    .jv-code {
      .jv-toggle {
        &:before {
          padding: 0px 2px;
          border-radius: 2px;
        }

        &:hover {
          &:before {
            background: #eee;
          }
        }
      }
    }
  }
</style>
